import { BuyerGroup } from '../../../types';

export const ConsumerPrivacyAction = {
  FETCH_CONSUMERPRIVACY: 'FETCH_CONSUMERPRIVACY',
  SHOW_CONSUMERPRIVACY: 'SHOW_CONSUMERPRIVACY',
  HIDE_CONSUMERPRIVACY: 'HIDE_CONSUMERPRIVACY', //jeds
  UPDATE_CONSUMERPRIVACY_ITEM: 'UPDATE_CONSUMERPRIVACY_ITEM',
  SAVE_CONSUMERPRIVACY: 'SAVE_CONSUMERPRIVACY',
  UPDATE_CONSUMERPRIVACY_LIST: 'UPDATE_CONSUMERPRIVACY_LIST',
  DELETE_CONSUMERPRIVACY: 'DELETE_CONSUMERPRIVACY',
  CLONE_CONSUMERPRIVACY: 'CLONE_CONSUMERPRIVACY',
};

export const ConsumerPrivacyModalAction = {
  CREATE: 'MODAL_CREATE',
  EDIT: 'MODAL_EDIT',
  DELETE: 'MODAL_DELETE',
};

export const ConsumerPrivacyURL = {
  REVIEW: '/api/ConsumerPrivacy/Get',
  GETBYID: '/api/ConsumerPrivacy/Get',
  CREATE: '/api/ConsumerPrivacy/Merge',
  UPDATE: '/api/ConsumerPrivacy/Merge',
  DELETE: '/api/ConsumerPrivacy/Delete',
};
